export enum SalesReportVariant {
  Overview = 'overview',
  ByCustomer = 'byCustomer',
  ByItem = 'byItem',
}
